import helper from "./helper"

let getAccountsUrlWithParameters = helper.getAccountsUrlWithParameters

export default {
  getAccountsUrlWithParameters,
  AUTHENTICATE: {
    AUTHENTICATION: {
      LOGIN:
        /**
         * Получает URL для входа в систему
         * @param {Object} gets - Query-параметры
         * @returns {string} URL для аутентификации пользователя
         */
        (gets = null) => getAccountsUrlWithParameters(
          'authenticate|authentication|login',
          "post",
          gets
        ),
      LOGOUT:
        /**
         * Получает URL для выхода из системы
         * @param {Object} gets - Query-параметры
         * @returns {string} URL для завершения сессии пользователя
         */
        (gets = null) => getAccountsUrlWithParameters(
          'authenticate|authentication|logout',
          'post',
          gets
        ),
      SESSION: {
        ALIVE:
          /**
           * Получает URL для проверки активности сессии
           * @param {Object} gets - Query-параметры
           * @returns {string} URL для проверки состояния сессии
           */
          (gets = null) => getAccountsUrlWithParameters(
            'authenticate|authentication|session|alive',
            'get',
            gets
          )
      },
      TOKEN: {
        ALIVE:
          /**
           * Получает URL для проверки активности токена
           * @param {Object} gets - Query-параметры
           * @returns {string} URL для проверки валидности токена
           */
          (gets = null) => getAccountsUrlWithParameters(
            'authenticate|authentication|token|alive',
            'post',
            gets
          )
      }
    }
  },
}
